var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apple_Store",
    "data-name": "Apple Store",
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.504,
    height: 25.1,
    viewBox: "0 0 99.504 25.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    transform: "translate(-1.996 -0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    d: "M16.8,12.7a4.909,4.909,0,0,1,2.4-4.2,5.262,5.262,0,0,0-4-2.2c-1.7-.2-3.3,1-4.2,1s-2.2-1-3.6-1A5.638,5.638,0,0,0,2.9,9.2c-1.9,3.3-.5,8.3,1.4,11,.9,1.3,2,2.8,3.4,2.8,1.4-.1,1.9-.9,3.6-.9s2.1.9,3.6.9,2.4-1.3,3.3-2.7a8.924,8.924,0,0,0,1.5-3.1A5.033,5.033,0,0,1,16.8,12.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    d: "M14.1,4.6a4.908,4.908,0,0,0,1.1-3.5A4.638,4.638,0,0,0,12,2.8a4.528,4.528,0,0,0-1.1,3.4A4.521,4.521,0,0,0,14.1,4.6Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2623",
    "data-name": "Group 2623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M34.3,19.5H29.6l-1.1,3.4h-2L31,10.5h2l4.5,12.4h-2ZM30.1,18h3.8L32,12.5h-.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M47.2,18.4c0,2.8-1.5,4.6-3.8,4.6a2.906,2.906,0,0,1-2.8-1.6h0v4.5H38.7v-12h1.8v1.5h0a3.356,3.356,0,0,1,2.9-1.6C45.7,13.7,47.2,15.6,47.2,18.4Zm-1.9,0c0-1.8-.9-3-2.4-3-1.4,0-2.4,1.2-2.4,3s1,3,2.4,3S45.3,20.2,45.3,18.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M57.2,18.4c0,2.8-1.5,4.6-3.8,4.6a2.906,2.906,0,0,1-2.8-1.6h0v4.5H48.7v-12h1.8v1.5h0a3.356,3.356,0,0,1,2.9-1.6C55.6,13.7,57.2,15.6,57.2,18.4Zm-2,0c0-1.8-.9-3-2.4-3-1.4,0-2.4,1.2-2.4,3s1,3,2.4,3c1.5,0,2.4-1.2,2.4-3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M63.7,19.4c.1,1.2,1.3,2,3,2,1.6,0,2.7-.8,2.7-1.9,0-1-.7-1.5-2.3-1.9l-1.6-.4c-2.3-.6-3.3-1.6-3.3-3.3,0-2.1,1.9-3.6,4.5-3.6s4.4,1.5,4.5,3.6H69.3a2.315,2.315,0,0,0-2.6-2c-1.5,0-2.5.8-2.5,1.9,0,.9.7,1.4,2.3,1.8l1.4.3c2.5.6,3.6,1.6,3.6,3.4,0,2.3-1.9,3.8-4.8,3.8-2.8,0-4.6-1.4-4.7-3.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M75.4,11.7v2.1h1.7v1.5H75.4v5c0,.8.3,1.1,1.1,1.1h.6v1.5a3.4,3.4,0,0,1-1,.1c-1.8,0-2.5-.7-2.5-2.4V15.4H72.3V13.9h1.3V11.8h1.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M78.1,18.4c0-2.8,1.7-4.6,4.3-4.6s4.3,1.8,4.3,4.6c0,2.9-1.7,4.6-4.3,4.6S78.1,21.2,78.1,18.4Zm6.7,0c0-2-.9-3.1-2.4-3.1S80,16.4,80,18.4s.9,3.1,2.4,3.1,2.4-1.2,2.4-3.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M88.2,13.8H90v1.5h0a2.069,2.069,0,0,1,2.2-1.6,1.268,1.268,0,0,1,.6.1v1.7a2.485,2.485,0,0,0-.8-.1,1.88,1.88,0,0,0-1.9,1.8v5.7H88.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M101.4,20.2c-.2,1.6-1.9,2.8-3.9,2.8-2.6,0-4.3-1.8-4.3-4.6s1.6-4.7,4.2-4.7c2.5,0,4.1,1.7,4.1,4.5v.6H95.1v.1a2.425,2.425,0,0,0,2.1,2.6h.3a1.962,1.962,0,0,0,2.1-1.3Zm-6.3-2.7h4.5a2.219,2.219,0,0,0-2.1-2.3h-.2a2.309,2.309,0,0,0-2.2,2.3Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    transform: "translate(-1.996 -0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2624",
    "data-name": "Group 2624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M29.9,1.1a2.6,2.6,0,0,1,2.8,2.4V4c0,1.9-1,3-2.8,3H27.7V1h2.2ZM28.6,6.2h1.1a1.894,1.894,0,0,0,2-1.8V4a1.9,1.9,0,0,0-1.6-2.1H28.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M33.7,4.8a2.11,2.11,0,0,1,4.2-.4v.4A2.139,2.139,0,0,1,36,7.2a2.061,2.061,0,0,1-2.3-1.9Zm3.3,0q0-1.5-1.2-1.5c-.8,0-1.2.6-1.2,1.5,0,1,.4,1.6,1.2,1.6S37,5.8,37,4.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M43.6,7.1h-.9l-.9-3.3h-.1l-.9,3.3h-.9L38.7,2.6h.9L40.3,6h.1l.9-3.4h.9L43.1,6h.1L44,2.6h.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M45.9,2.6h.9v.7h.1a1.441,1.441,0,0,1,1.3-.8,1.316,1.316,0,0,1,1.5,1.3V7h-.9V4.4c0-.7-.3-1.1-1-1.1a1.028,1.028,0,0,0-1.1,1V7.1h-.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M51.1.8H52V7.1h-.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M53.2,4.8a2.11,2.11,0,0,1,4.2-.4v.4a2.11,2.11,0,0,1-4.2.4Zm3.4,0q0-1.5-1.2-1.5c-.8,0-1.2.6-1.2,1.5,0,1,.4,1.6,1.2,1.6C56.1,6.4,56.6,5.8,56.6,4.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M58.4,5.8c0-.8.6-1.3,1.7-1.3l1.2-.1V4c0-.5-.3-.7-.9-.7-.5,0-.8.2-.9.5h-.9a1.611,1.611,0,0,1,1.8-1.3c1.1,0,1.8.6,1.8,1.5V7.1h-.9V6.5h-.1a1.513,1.513,0,0,1-1.4.7A1.418,1.418,0,0,1,58.3,6C58.4,5.9,58.4,5.9,58.4,5.8Zm2.9-.4V5.1l-1.1.1c-.6,0-.9.3-.9.6,0,.4.4.6.8.6a1.055,1.055,0,0,0,1.2-1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M63.4,4.8c0-1.4.7-2.3,1.9-2.3a1.6,1.6,0,0,1,1.4.8h.1V.8h.9V7.1h-.9V6.4h-.1a1.6,1.6,0,0,1-1.4.8C64.1,7.2,63.4,6.3,63.4,4.8Zm.9,0c0,1,.5,1.5,1.2,1.5s1.2-.6,1.2-1.5-.5-1.5-1.2-1.5c-.8,0-1.2.6-1.2,1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M71.3,4.8a2.11,2.11,0,0,1,4.2-.4v.4a2.212,2.212,0,0,1-1.9,2.4,2.061,2.061,0,0,1-2.3-1.9A.454.454,0,0,1,71.3,4.8Zm3.3,0q0-1.5-1.2-1.5c-.8,0-1.2.6-1.2,1.5,0,1,.4,1.6,1.2,1.6S74.6,5.8,74.6,4.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M76.7,2.6h.9v.7h.1A1.441,1.441,0,0,1,79,2.5a1.467,1.467,0,0,1,1.6,1.4V7.1h-.9V4.4c0-.7-.3-1.1-1-1.1a1.028,1.028,0,0,0-1.1,1V7.1h-.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M85.5,1.5V2.6h1v.7h-1V5.6c0,.5.2.7.6.7h.3V7h-.5c-1,0-1.4-.3-1.4-1.2V3.4h-.7V2.6h.7V1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M87.7.8h.9V3.3h.1a1.339,1.339,0,0,1,1.4-.8,1.617,1.617,0,0,1,1.6,1.4V7.1h-.9V4.4c0-.7-.3-1.1-1-1.1a1.028,1.028,0,0,0-1.1,1V7.1h-.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M96.8,5.9a1.881,1.881,0,0,1-2,1.3,2.094,2.094,0,0,1-2.1-2V4.9a1.976,1.976,0,0,1,1.8-2.3h.3c1.3,0,2,.9,2,2.3v.3H93.6a1.155,1.155,0,0,0,1.1,1.3h.1A1.173,1.173,0,0,0,95.9,6ZM93.7,4.4H96a1.188,1.188,0,0,0-1-1.2h-.1a1.216,1.216,0,0,0-1.2,1.2Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.8f82b82c00ccc330910353fb17c8448d.svg";
export { ForwardRef as ReactComponent };